import { MapPin, Hourglass, Timer, Navigation, MessageCircle, RotateCcw } from "lucide-react";
import { jobFor } from "@/lib/playEngine";

export function PositionPicker({ play, posId, setPosId }) {
  return (
    <div data-testid="position-picker">
      <p className="label">Pick your position</p>
      <div className="flex flex-wrap gap-2">
        {["offense", "defense"].map((side) => play.players.filter((p) => p.side === side).map((p) => (
          <button key={p.id} onClick={() => setPosId(p.id)} aria-pressed={posId === p.id} className={`btn px-3 ${posId === p.id ? "btn-primary" : "btn-ghost"}`} data-testid={`pick-position-${p.label}`}>
            <span className={p.side === "offense" ? "w-3 h-3 rounded-full border-2 border-current" : "w-2.5 h-2.5 rotate-45 border-2 border-current"} aria-hidden="true" />
            {p.label}{p.nickname && <span className="font-normal opacity-80">· {p.nickname}</span>}
          </button>
        )))}
      </div>
    </div>
  );
}

const STEPS = [
  ["lineup", "Where to line up", MapPin],
  ["before", "Before the snap", Hourglass],
  ["when", "When to go", Timer],
  ["where", "Where to move", Navigation],
];

export function JobCard({ play, player, onReplay }) {
  const job = jobFor(play, player);
  return (
    <div className="card p-5 space-y-4 tpc-rise" data-testid="job-card">
      <div className="flex items-center justify-between gap-2">
        <p className="font-display text-3xl font-extrabold uppercase">My job: <span className="text-[#FF8A1F]" data-testid="job-position">{player.label}</span></p>
      </div>
      <ol className="space-y-3">
        {STEPS.map(([k, t, Icon], i) => (
          <li key={k} className="flex gap-3" data-testid={`job-step-${k}`}>
            <span className="grid place-items-center w-10 h-10 shrink-0 rounded-full bg-[#FF6B00]/15 text-[#FF8A1F] font-display text-xl font-extrabold">{i + 1}</span>
            <div><p className="text-xs font-bold uppercase tracking-wider text-slate-400 flex items-center gap-1"><Icon size={14} />{t}</p><p className="text-base text-white">{job[k]}</p></div>
          </li>
        ))}
      </ol>
      {job.instruction && (
        <div className="rounded-xl bg-[#FACC15]/10 border border-[#FACC15]/40 p-3 flex gap-2" data-testid="job-coach-tip">
          <MessageCircle size={20} className="text-[#FACC15] shrink-0" /><p><b>Coach says:</b> {job.instruction}</p>
        </div>
      )}
      <button className="btn btn-primary w-full text-base" onClick={onReplay} data-testid="btn-replay-assignment"><RotateCcw size={18} />Replay My Assignment</button>
    </div>
  );
}
